class QuickShareModal extends ModalDialog {
  constructor() {
    super();
    this.modalContent = this.querySelector('#QuickShareInfo');
    this.cardWrapper = this.querySelector('.share-product-card');
    this.shareData;
  }

  connectedCallback() {
    super.connectedCallback();
    this.copyLink();
  }

  show(opener) {
    opener.classList.add('loading');
    const productHandle = opener?.dataset?.productHandle;
    fetch(`/?sections=card-product&product_handle=${productHandle}`)
      .then((res) => res.json())
      .then((data) => {
        const html = data['card-product'];
        const responseHTML = new DOMParser().parseFromString(html, 'text/html');
        const productElement = responseHTML.querySelector(
          '#shopify-section-card-product',
        );
        this.preprocessHTML(productElement);
        HTMLUpdateUtility.setInnerHTML(
          this.cardWrapper,
          productElement.outerHTML,
        );

        this.shareData = [
          productElement.querySelector('.card__information>h3>a').href,
          productElement.querySelector('.card__information>h3>a').textContent,
        ];
        this.shareLink(this.shareData);
      })
      .then(() => {
        super.show(opener);
        opener.classList.remove('loading');
        document.body.setAttribute('style', 'overflow: hidden;');
      })
      .catch((err) => {
        console.error('Fetch error:', err);
      });
  }
  preprocessHTML(productElement) {
    const cardIcons = productElement.querySelector('.card_icon_list');
    if (cardIcons) {
      cardIcons.remove();
    }
    const quickAdd = productElement.querySelector('.quick-add');
    if (quickAdd) {
      quickAdd.remove();
    }
    const cardIInner = productElement.querySelector('.card__inner');
    const cardMedia = productElement.querySelector(
      '.card-wrapper>.card--media',
    );
    if (cardIInner || cardMedia) {
      cardIInner.style.setProperty('--ratio-percent', '100%');
      cardMedia.style.setProperty('--ratio-percent', '100%');
    }

    return productElement;
  }

  shareLink() {
    const facebookURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      this.shareData[0],
    )}`;
    const twitterURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      this.shareData[0],
    )}&text=${encodeURIComponent(this.shareData[1])}`;
    const linkedinURL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      this.shareData[0],
    )}`;
    const whatsappURL = `https://wa.me/?text=${encodeURIComponent(
      `${this.shareData[1]} ${this.shareData[0]}`,
    )}`;
    const pinterestURL = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
      this.shareData[0],
    )}&description=${this.shareData[1]}`;

    this.querySelector('.social-links>li>a.facebook').href = facebookURL;
    this.querySelector('.social-links>li>a.whatsapp').href = whatsappURL;
    this.querySelector('.social-links>li>a.x').href = twitterURL;
    this.querySelector('.social-links>li>a.pinterest').href = pinterestURL;

    this.querySelector('.share-link-wrapper input').value = this.shareData[0];
  }
  copyLink() {
    const link = this.querySelector('.share-link input');
    const copyBtn = this.querySelector('.share-link button');
    let buttonName = copyBtn.querySelector('span');
    let buttonOrgName;
    if (!buttonOrgName) {
      buttonOrgName = buttonName.textContent;
    }

    copyBtn.addEventListener('click', () => {
      link.select();
      link.setSelectionRange(0, 99999);
      document.execCommand('copy');
      buttonName.textContent = 'Copied!';
      setTimeout(() => {
        buttonName.innerHTML = buttonOrgName;
      }, 2000);
    });
  }
}

// Define the new custom element
customElements.define('quick-share-modal', QuickShareModal);
